import MenuItem from '@mui/material/MenuItem'
import {FC} from 'react'
import {useDispatch} from 'react-redux'
import {continentsList, setFilter, useAllSearchFilters} from 'entities/searchPeople'
import {Select} from 'shared/ui/select'
import {SelectSearchTransform} from 'shared/ui/selectSearch'

export const SPContinents: FC<SelectSearchTransform> = ({...rest}) => {
  const dispatch = useDispatch()
  const {continents} = useAllSearchFilters()

  return (
    <Select
      {...rest}
      value={continents}
      onChange={(event) => dispatch(setFilter({value: event.target.value, key: 'continents'}))}
      displayEmpty
      placeholder='All continents'
    >
      {
        continentsList.map((item) => <MenuItem key={item.id} value={item.id}>{item.label}</MenuItem>)
      }
    </Select>
  )
}